const CLIENT_REFERENCE_FIELD = 'external_id';
const BOOKING_NUMBER_FIELD = 'booking_number';
const REFERENCE_NUMBER_FIELD = 'reference_number';
const SEAL_NUMBER_FIELD = 'seal_number';
const CONTAINER_TYPE_FIELD = 'container_iso_code';
const LOCATOR_PICKUP_FIELD = 'acceptance_locator_code';
const LOCATOR_DROPOFF_FIELD = 'release_locator_code';
const BUNKER_ADJUSTMENT_FACTOR_EXTRA = 'BUNKER_ADJUSTMENT_FACTOR';
const INCREMENT_FOR_USING_WEIGHING_SCALE_EXTRA = 'INCREMENT_FOR_USING_WEIGHING_SCALE';
const INCREMENT_FOR_WEIGHT_OVERLOAD_EXTRA = 'INCREMENT_FOR_WEIGHT_OVERLOAD';

export {
  CLIENT_REFERENCE_FIELD,
  BOOKING_NUMBER_FIELD,
  REFERENCE_NUMBER_FIELD,
  SEAL_NUMBER_FIELD,
  CONTAINER_TYPE_FIELD,
  LOCATOR_DROPOFF_FIELD,
  LOCATOR_PICKUP_FIELD,
  BUNKER_ADJUSTMENT_FACTOR_EXTRA,
  INCREMENT_FOR_USING_WEIGHING_SCALE_EXTRA,
  INCREMENT_FOR_WEIGHT_OVERLOAD_EXTRA,
};
